import Vue from 'vue';

import Wishlist from '../components/wishlist.js';

new Vue({
    el: '#template-wishlist',

    delimiters: ['${', '}'],

    components: {
        Wishlist
    }
});